// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-38b2c802] .el-dialog__header{padding:16px 14px 36px 36px}", ""]);
// Exports
module.exports = exports;
